var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M7 10.0007L12 4.00073L17 10.0007M21 10.0007L19 18.0007C18.9065 18.5739 18.6552 19.088 18.2897 19.4534C17.9243 19.8188 17.4679 20.0125 17 20.0007H7C6.53211 20.0125 6.07572 19.8188 5.71028 19.4534C5.34485 19.088 5.0935 18.5739 5 18.0007L3 10.0007H21ZM14 15.0007C14 16.1053 13.1046 17.0007 12 17.0007C10.8954 17.0007 10 16.1053 10 15.0007C10 13.8962 10.8954 13.0007 12 13.0007C13.1046 13.0007 14 13.8962 14 15.0007Z", stroke: "#222429", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
  );
});